import type { EIntelligentType } from '../constant'
import type { Message } from '../models/message'
import type { IHistoryRes, ISenceListInfo, ISessionFile } from '../types'
import { post } from '@/utils/request'

/**
 * 创建历史会话记录
 */
interface ICreateHistory {

  id?: number
  title?: string
}
export const createHistory = <T>(data: ICreateHistory) => {
  return post<T>({
    url: '/assistant/intelligentAssistant/history/insert',
    data,
  })
}

/**
 * 获取历史会话记录列表
 */
interface IHistoryList {
  'bean': {
    'businessType': number
    'enterpriseId': string
  }
  'page': number
  'pageSize': number
}
export const getHistoryListApi = <T = IHistoryRes>(data: IHistoryList) => {
  return post<T>({
    url: '/assistant/intelligentAssistant/answerRecord/getAnswerRecord',
    data,
  })
}

/**
 * 记录点赞
 */
interface ILike {
  requestId: Message['requestId']
  role: Message['role']
  status: Message['status']
}
export const likeApi = <T = boolean>(data: ILike) => {
  return post<T>({
    url: '/assistant/intelligentAssistant/answerRecord/like',
    data,
  })
}

/**
 * 获取记录的ID
*/
export interface IGetChatId {
  content: string
  contentGpt: string
  sessionId: string
  historyId: string
  rangeId?: string
  businessType: EIntelligentType
  createTime: string
  enterpriseId: number | null
  placeholders?: {
    '{digest}': string
  }
}
export const getChatId = (data: IGetChatId) => {
  return post<{
    'historyId': string
    'sessionId': string
    'streamId': string
  }>({
    url: '/assistant/intelligentAssistant/chat/conversation/stream/v2',
    data,
  })
}

// 獲取場景列表信息
export const getSenceInfoList = () => {
  return post<ISenceListInfo[]>({
    url: '/assistant/intelligentAssistant/assistantScene/getSceneList',
    data: {
      scope: 1,
    },
  })
}

// 创建会话
interface ICreateSession {
  'sceneId': number
  'sessionName'?: string
  'paramList'?: any[]
}
export const createSession = <T>(data: ICreateSession) => {
  return post<T>({
    url: '/assistant/intelligentAssistant/session/insert',
    data,
  })
}

/**
 * 获取文档回复的范围
 */
export enum ERangeType {
  DEFAULT,
  PRODUCT,
  FILE,
  FOLDER,
  BASE,
  BASES,
}
interface IDoc {
  fileId: number
  fileName: string
}
export interface IRangeParams {
  question: string
  ranges: {
    allSelect?: boolean
    businessId?: number
    businessName?: string
    docs: IDoc[]
    type: ERangeType
    model?: number | null // 模型 null: beautyGPT; 8: R1
  }[]
  businessType?: number
}

interface IRangeResponse {
  searchResult: string
  docList: IDoc[]
  rangeId: string
  docReplyType: number
}
export const getRange = <T = IRangeResponse>(data: IRangeParams) => {
  return post<T>({
    url: '/assistant/intelligentAssistant/chat/getPromptByQuestionAndRange/v2',
    data,
  })
}

export interface ISearchParams extends IRangeParams {
  firstLevelId: number
  require: string
  createTime: string
  fileRangeName: string
  enterpriseId: number | null
  historyId: number | string
}
export const searchDocData = (data: ISearchParams) => {
  return post<{
    noResultReply: string | null
    simpleFileVos: ISessionFile[]
    requestId: string
  }>({
    url: '/assistant/lib/file/searchDocData',
    data,
  })
}
